import React from "react";
import classNames from "classnames";
import CardWrapper from "../../layouts/CardWrapper";
import styles from "./DetailsPanel.module.scss";

const DetailsPanel = ({ isOpen, children }) => {
  return (
    <CardWrapper
      className={classNames(
        styles["detail-panel"],
        { [styles.open]: isOpen },
        "detail-panel-box"
      )}
    >
      {children}
    </CardWrapper>
  );
};

export default DetailsPanel;
